<template>
  <div class="flex col-12 justify-between items-center p1">
    <div class="flex col-2 justify-start items-center">
      <div class="flex justify-center custom-radio user-icon aqua-bg">
        <i class="icon i-user flex h1 white"></i>
      </div>
    </div>
    <div class="flex flex-wrap col-7 items-center">
      <div class="flex col-12 bold">{{ participant.firstname }} {{ participant.lastname }}</div>
      <div v-if="participant.birth_date" class="flex col-12">{{ participant.birth_date }} - ({{ participantAge(participant.birth_date) }} ans)</div>
    </div>
    <div class="flex col-2 items-center justify-end">
      <div class="flex items-center full-height">
        <span
          :class="['flex custom-radio pointer', { 'selected-item': isSelected }]"
          @click="selectParticipant()"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { differenceInYears } from 'date-fns';

export default {
  components: { },
  props: {
    participant: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentParticipant () {
      return this.$store.state.currentParticipant;
    },
    isSelected () {
      return (
        this.currentParticipant
        && this.currentParticipant.uuid === this.participant.uuid
      );
    },
    isBuyer () {
      return this.$store.state.user.uuid === this.participant.uuid;
    }
  },
  mounted () {
    if (!this.currentParticipant && this.isBuyer) {
      this.$store.commit('setCurrentParticipant', this.participant);
    }
  },
  methods: {
    participantAge (birthDate) {
      const date = birthDate.split('/').reverse().join('-');
      return differenceInYears(new Date(), new Date(date));
    },
    selectParticipant () {
      this.$store.commit('setCurrentParticipant', this.participant);
    }
  }
};
</script>

<style scoped>
.custom-radio.user-icon{
  height: 50px;
  width: 50px;
}
.icon:before {
  display: flex;
  align-items: center;
}
</style>
